import React, { createContext, useContext, useState } from 'react'

interface MemberTableContextType{
  selectedUser: String;
  setSelectedUser: React.Dispatch<React.SetStateAction<string>>
  selectedMemberPreset: String;
  setSelectedMemberPreset: React.Dispatch<React.SetStateAction<string>>
  selectedModal: String;
  setSelectedModal: React.Dispatch<React.SetStateAction<string>>
  useHeader: {};
  setUseHeader: React.Dispatch<React.SetStateAction<{}>>
  refetchMembers: null;
  setRefetchMembers: React.Dispatch<React.SetStateAction<null>>
  refetchMemberPresets: null;
  setRefetchMemberPresets: React.Dispatch<React.SetStateAction<null>>
  refetchPendingInvites: null;
  setRefetchPendingInvites: React.Dispatch<React.SetStateAction<null>>
  refetchInviteLinks: null;
  setRefetchInviteLinks: React.Dispatch<React.SetStateAction<null>>
  refetchSentInvites: null;
  setRefetchSentInvites: React.Dispatch<React.SetStateAction<null>>
  refetchJoinRequests: null;
  setRefetchJoinRequests: React.Dispatch<React.SetStateAction<null>>
  selectedBulkUser: String;
  setSelectedBulkUser: React.Dispatch<React.SetStateAction<string>>
}

const MemberTableContext = createContext<MemberTableContextType | null>(null)

export const MemberTableProvider: React.FC = ({ children }) => {
  const [ selectedUser, setSelectedUser ] = useState('')
  const [ selectedMemberPreset, setSelectedMemberPreset ] = useState('')
  const [ selectedModal, setSelectedModal ] = useState('')
  const [ useHeader, setUseHeader ] = useState({})
  const [ refetchMembers, setRefetchMembers ] = useState(null)
  const [ refetchMemberPresets, setRefetchMemberPresets ] = useState(null)
  const [ refetchPendingInvites, setRefetchPendingInvites ] = useState(null)
  const [ refetchInviteLinks, setRefetchInviteLinks ] = useState(null)
  const [ refetchSentInvites, setRefetchSentInvites ] = useState(null)
  const [ refetchJoinRequests, setRefetchJoinRequests ] = useState(null)
  const [ selectedBulkUser, setSelectedBulkUser ] = useState('')

  return(
    <MemberTableContext.Provider value={{
      selectedUser,
      setSelectedUser,
      selectedMemberPreset,
      setSelectedMemberPreset,
      selectedModal,
      setSelectedModal,
      useHeader,
      setUseHeader,
      refetchMembers, 
      setRefetchMembers,
      refetchMemberPresets, 
      setRefetchMemberPresets,
      refetchPendingInvites, 
      setRefetchPendingInvites,
      refetchInviteLinks, 
      setRefetchInviteLinks,
      refetchSentInvites, 
      setRefetchSentInvites,
      refetchJoinRequests, 
      setRefetchJoinRequests,
      selectedBulkUser,
      setSelectedBulkUser
    }}>
      { children }
    </MemberTableContext.Provider>
  )
}

const useMemberTable = (): MemberTableContextType => {
  const context = useContext(MemberTableContext)
  if( !context ){
    throw new Error('useMemberTable must be used within a MemberTableProvider');
  }
  return context
}

export default useMemberTable
